export const hasNumberRangeValue = (
  minValue?: number | null,
  maxValue?: number | null,
): boolean => {
  return (
    (minValue !== undefined && minValue !== null) ||
    (maxValue !== undefined && maxValue !== null)
  );
};
